import {randomId,View,map} from "vritra";
import css from "./TableExample.module.css";


export default function TableExample(props){
    const {parent,id=randomId("tableexample")}=props;
    const tableexample=View({parent,id,className:css.tableexample});

    tableexample.innateHTML=`
        <table class="${css.table}">
            <tr>
                ${map(statics.metadata,(label)=>`<th>${label}</th>`)}
            </tr>
            ${map(statics.data,(person,i)=>`
                <tr>
                    ${map(statics.metadata,(label,j)=>`
                        <td>${j?person[label]:i+1}</td>
                    `)}
                </tr>
            `)}
        </table>
    `;

    return tableexample;
}

const statics={
    metadata:["N°","name","age"],
    data:[
        {name:"patrick",age:52},
        {name:"amine",age:20},
        {name:"vanessa",age:26},
        {name:"adrian",age:22},
        {name:"bruno",age:15},
        {name:"scott",age:43},
        {name:"maya",age:24},
    ],
}
